import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (!navigator.userAgent.match(/Android/i) &&
            !navigator.userAgent.match(/webOS/i) &&
            !navigator.userAgent.match(/iPhone/i) &&
            !navigator.userAgent.match(/iPad/i) &&
            !navigator.userAgent.match(/iPod/i) &&
            !navigator.userAgent.match(/BlackBerry/i) &&
            !navigator.userAgent.match(/Windows Phone/i) || to.name === 'license' || to.name === 'privacy')
        {
            return {x: 0, y: 0}
        }
    },
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/movies',
            name: '',
            component: () => import('./views/MoviesPage.vue'),
            children: [
                {
                    path: ':category',
                    name: 'movies',
                    component: () => import('./views/MediaTab.vue'),
                    props: true,
                },
            ],
            props: true,
        },
        {
            path: '/kids',
            name: '',
            component: () => import('./views/KidsPage.vue'),
            children: [
                {
                    path: ':category',
                    name: 'kids',
                    component: () => import('./views/MediaTab.vue'),
                    props: true,
                },
            ],
            props: true,
        },
        {
            path: '/tv',
            name: '',
            component: () => import('./views/TvPage.vue'),
            children: [
                {
                    path: ':category',
                    name: 'tv',
                    component: () => import('./views/MediaTab.vue'),
                    props: true,
                },
            ],
            props: true,
        },
        {
            path: '/music',
            name: '',
            component: () => import('./views/MusicPage.vue'),
            children: [
                {
                    path: ':category',
                    name: 'music',
                    component: () => import('./views/MediaTab.vue'),
                    props: true,
                },
            ],
            props: true,
        },
        {
            path: '/games',
            name: '',
            component: () => import('./views/GamesPage.vue'),
            children: [
                {
                    path: ':category',
                    name: 'games',
                    component: () => import('./views/MediaTab.vue'),
                    props: true,
                },
            ],
            props: true,
        },
        {
            path: '/movie-info/:id',
            name: 'movie-info',
            component: () => import('./views/MovieInfo.vue'),
            props: true,
        },
        {
            path: '/music-info/:id',
            name: 'music-info',
            component: () => import('./views/MusicInfo.vue'),
            props: true,
        },
        {
            path: '/game-info/:id',
            name: 'game-info',
            component: () => import('./views/GameInfo.vue'),
            props: true,
        },
        {
            path: '/license',
            name: 'license',
            component: () => import('./views/License.vue')
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () => import('./views/PrivacyPolicy.vue')
        },
        {
            path: '/404',
            name: '404',
            component: () => import('./views/NotFound.vue')
        }, {
            path: '*',
            redirect: '/404'
        }
    ]
})
